export const dashboard = {
  charts: {
    cta: {
      createInvoice: 'Create invoice',
      text: 'As soon as your first invoice has been created, you can see your statistics here.',
      title: 'Create your first invoice',
    },
    labels: {
      copyright: 'Copyright income',
      currentQ: 'Current quarter (Q{{ quarter }})',
      expired: 'Overdue',
      notExpired: 'Not overdue',
      performance: 'Professional income',
      previousQ: 'Previous quarters',
    },
    overview: 'Overview',
    overviewChart: 'Chart with an overview of invoices by status',
    summary: {
      amountInvoices: 'Number of invoices',
      total: 'Total',
      value: 'Amount',
    },
    totalBilled: 'Total invoiced',
    totalBilledChart: 'Chart with an overview of invoices',
    yearSelector: 'Year – {{title}}',
  },
  error: {
    title: 'Error loading your dashboard.',
  },
  forumPostsSummary: {
    error: 'Posts not found',
    link: 'Go to the forum',
    title: 'Latest posts',
  },
  frameworkAgreement: {
    alreadySigned: 'You’ve already agreed to the framework agreement.',
    checkboxError: 'To get started, you need to agree to the framework agreement.',
    checkboxLabel: 'I agree to the framework agreement.',
    subtitle: 'No small or hidden print, just clear agreements.',
    title: 'Read the framework agreement',
  },
  header: {
    actionBlock: {
      button: 'Create invoice',
      dropdown: {
        client: 'Create client',
        creditnote: 'Create credit note',
        quotation: 'Create quotation',
      },
    },
  },
  jobPostsSummary: {
    error: 'Assignments not found',
    link: 'Go to the assignments',
    title: 'Latest assignments',
  },
  outstandingInvoices: {
    expired: '{{amount}} overdue',
    summary_one: '{{count}} invoice',
    summary_other: '{{count}} invoices',
    summaryWithExpired_one: '{{count}} invoice, {{expiredCount}} overdue',
    summaryWithExpired_other: '{{count}} invoices, {{expiredCount}} overdue',
    table: {
      amount: 'Amount',
      dueDate: 'Due date',
      invoice: 'Invoice',
    },
    title: 'Outstanding invoices',
    toReceive: 'Still to receive',
    viewAll: 'View all outstanding invoices',
  },
  progression: {
    progress: '{{completedSteps}} of {{totalSteps}} completed',
    steps: {
      completed: 'Completed:',
      create: 'Create and activate your account',
      createInvoice: {
        text: 'Complete the other steps first',
        title: 'Create and send your first invoice',
      },
      iban: 'Enter your account number',
      peppol: 'Register your Peppol inbox',
      signAddendum2024: 'Sign the addendum to your framework agreement with Creative Shelter',
      signContract: 'Sign your framework agreement',
      signContractModalTitle: 'Sign your Creative Shelter framework agreement',
      uncompleted: 'To do:',
      vatRegulation: 'Indicate your VAT status',
    },
    subtitle_one: '{{count}} more step before you can send your first invoice.',
    subtitle_other: '{{count}} more steps before you can send your first invoice.',
    subtitle_zero: 'You’re ready to send your first invoice!',
    title: 'Complete your account',
  },
  stats: {
    copyrightAverage: {
      label: 'Average copyright income',
      tooltip:
        'Four-year average you received as copyright income through Creative Shelter.<br>Why this matters and how it’s calculated, <a href="https://knowledge.creativeshelter.be/hoe-wordt-jouw-gemiddelde-auteursrechten-berekend-op-het-dashboard" target="_blank">you can read here</a>.',
    },
    copyrightThisYear: {
      label: 'Total copyright income in {{year}}',
      tooltip:
        'Total copyright income from all your paid invoices this year. <br>You can read all about the annual limit on your copyright income <a href="https://www.creativeshelter.be/begroting-hervorming-van-auteursrecht/" target="_blank">here</a>.',
    },
    error: {
      title: 'Error loading your dashboard.',
    },
    invoicedSumThisYear: {
      label: 'Total income in {{year}}',
      tooltip: 'Total amount you’ve invoiced through our platform this year.',
    },
    title: 'Statistics',
  },
};
